import Script from 'next/script'
import { FC } from 'react'

interface SchemaArticle {
  url: string
  datePublished: string
  headline: string
  previewUrl: string
  keywords: string
  articleBody: string
  description: string
  thumbnailUrl: string
  dateline: string
  aboutUrl: string
  descriptionArticle: string
}

const SchemaArticle: FC<SchemaArticle> = ({
  url,
  datePublished,
  headline,
  previewUrl,
  keywords,
  articleBody,
  description,
  thumbnailUrl,
  dateline,
  aboutUrl,
  descriptionArticle,
}) => {
  return (
    <Script
      id="schema-org"
      strategy="beforeInteractive"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: `
        {
            "@context": "https://schema.org",
            "@type": "NewsArticle",
            "publisher": {
              "@type": "Organization",
              "name": "Kristall Minerals сosmetics",
              "url": "${process.env.NEXT_PUBLIC_DOMAIN_ENDPOINT}",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Пр-кт Медиков 5В, бизнес-центр Карповка, этаж 4, офис 403",
                "postalCode": "197022",
                "addressLocality": "Санкт-Петербург",
                "addressRegion": "Ленинградская обл.",
                "addressCountry": {
                  "@type": "Country",
                  "name": "Россия"
                }
              },
              "logo": {
                "@type": "ImageObject",
                "url": "https://kmcosmetics.ru/static/favicon/apple-icon-144x144.png",
                "width": "144",
                "height": "144"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "worstRating": "1",
                "bestRating": "5",
                "ratingValue": "4.9",
                "ratingCount": "250"
              }
            },
            "headline": "${headline}",
            "url": "${url}",
            "datePublished": "${datePublished}",
            "dateModified": "${datePublished}",
            "image": {
              "@type": "ImageObject",
              "url": "${previewUrl}",
              "width": 1280,
              "height": 680
            },
            "keywords": "${keywords}",
            "articleBody":"${articleBody}",
            "inLanguage": "ru",
            "about": [
                {
                "type": "https://schema.org/Dataset",
                "name": "Статьи",
                "url": "${aboutUrl}",
                "description": "${description}"
                }
            ],
            "thumbnailUrl":"${thumbnailUrl}",
            "dateline":"${dateline}",
            "genre":"Статьи",
            "description": "${descriptionArticle}",
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": "${url}"
            }
          }
        `,
      }}
    />
  )
}
export default SchemaArticle
